import { api } from './api'
import { apiErrorMessage } from './apiError'

// api.* ApiError fırlatır: toApiError(error).message önce backend'in TR mesajını,
// yoksa hata türüne göre yerel metni verir. Ham `error.message` okumak, ApiError
// olmayan hatalarda İngilizce JS metnini kullanıcıya sızdırıyordu.

export interface User {
  id: number
  first_name: string
  last_name: string
  email: string
  role: 'admin' | 'operator' | 'superadmin' | 'customer'
  is_active: boolean
  created_at: string
  last_login_at?: string | null
  login_count?: number
  company_name?: string
  company?: number
  company_id?: number
}

interface UserApiResponse {
  success: boolean
  message: string
  data: User[]
}

interface SingleUserApiResponse {
  success: boolean
  message: string
  data?: User
}

interface UserActionResponse {
  success: boolean
  message: string
}

export interface AddUserData {
  first_name: string
  last_name: string
  email: string
  password: string
  role: 'admin' | 'operator' | 'superadmin' | 'customer'
  company_id: number
  is_active?: boolean
}

export interface UpdateUserData {
  first_name: string
  last_name: string
  email: string
  role: 'admin' | 'operator' | 'superadmin' | 'customer'
  company_id: number
  is_active?: boolean
}

export const userService = {
  async getUsers(userId?: number, role?: string, companyId?: number): Promise<UserApiResponse> {
    try {
      const params = new URLSearchParams()
      if (userId) params.append('user_id', userId.toString())
      if (role) params.append('role', role)
      if (companyId) params.append('company_id', companyId.toString())
      
      const response = await api.get(`/users?${params.toString()}`)
      return response as UserApiResponse
    } catch (error) {
      // data: [] burada "hiç kullanıcı yok" DEĞİL, sadece tip sözleşmesini karşılıyor.
      // success:false olduğu için çağıran ekran listeyi boşaltmamalı; mevcut veriyi
      // koruyup message'ı hata olarak göstermeli.
      return {
        success: false,
        message: apiErrorMessage(error, 'Kullanıcılar yüklenirken hata oluştu'),
        data: []
      }
    }
  },

  async addUser(userData: AddUserData): Promise<SingleUserApiResponse> {
    try {
      const response = await api.post('/users', userData)
      // Clear users cache after successful addition
      api.clearCache()
      return response as SingleUserApiResponse
    } catch (error) {
      return {
        success: false,
        message: apiErrorMessage(error, 'Kullanıcı eklenirken hata oluştu')
      }
    }
  },

  async updateUser(userId: number, userData: UpdateUserData): Promise<SingleUserApiResponse> {
    try {
      const response = await api.put(`/users/${userId}`, userData)
      // Clear users cache after successful update
      api.clearCache()
      return response as SingleUserApiResponse
    } catch (error) {
      return {
        success: false,
        message: apiErrorMessage(error, 'Kullanıcı güncellenirken hata oluştu')
      }
    }
  },

  async deleteUser(userId: number): Promise<UserActionResponse> {
    try {
      const response = await api.delete(`/users/${userId}`)
      // Clear users cache after successful deletion
      api.clearCache()
      return response as UserActionResponse
    } catch (error) {
      return {
        success: false,
        message: apiErrorMessage(error, 'Kullanıcı silinirken hata oluştu')
      }
    }
  },

  async changePassword(userId: number, newPassword: string): Promise<UserActionResponse> {
    try {
      const response = await api.put(`/users/${userId}/password`, { password: newPassword })
      return response as UserActionResponse
    } catch (error) {
      return {
        success: false,
        message: apiErrorMessage(error, 'Şifre değiştirilirken hata oluştu')
      }
    }
  }
} 